export enum ParcelBufferState {
    NO_PARCEL = 0,
    PARCEL = 1,
    RESERVED = 2,
    OWNED = 3,
    SELF_OWNED = 4,
    IMAGE = 5,
};